import React from "react";
// import { useSelector } from "react-redux";
import "./styles.css";
import { useSelector } from "react-redux";
import Performance from "./Performance/Performance";
import Pieces from "./Pieces/Pieces";
import Sessions from "./Sessions/Sessions";
import StudentInfo from "./StudentInfo/StudentInfo";
import AverageSummary from "../AverageSummary/AverageSummary";
import { CalendarView } from "../Calender/CalenderView/index";

const StudentSummary = () => {
  // const loading = useSelector((state) => state.teacherReducer.loading);
  const summaryStudent = useSelector(
    (state) => state.teacherReducer.currentStudent,
  );
  return (
    <>
      {summaryStudent && (
        <div className="student-summary-container">
          <div>
            <Performance summaryStudent={summaryStudent} />
            <CalendarView studentId={summaryStudent} />
          </div>
          <div className="sessions-pieces-container">
            <StudentInfo summaryStudent={summaryStudent} />
            <div className="inner-container">
              <Sessions summaryStudent={summaryStudent} />
              <Pieces summaryStudent={summaryStudent} />
            </div>
          </div>
        </div>
      )}
      {!summaryStudent && (
        <div className="average-summary-container">
          <AverageSummary />
        </div>
      )}
    </>
  );
};

export default StudentSummary;
